import { Col, Row } from 'antd'
import AddBudgetModal from 'components/shared/Modals/AddBudgetModal'
import React, { FC, useState } from 'react'
import { useDeleteBudgetMutation } from 'features/leads/api'
import { globalConfirm } from 'components/elements/global'
import { TBudget } from 'features/leads/types'
import ProInnerCard from '../../ProInnerCard'
import SimpleBlockItem from '../../SimpleBlockItem'

export type TAddBudget = {
 budget?: string
 lead_id?: any
 budget_id?: any
}

const BudgetBlock: FC<{ budget?: TBudget[]; isTransferred?: boolean }> = ({
 budget,
 isTransferred,
}) => {
 const [showModal, setShowModal] = useState<{
  show?: boolean
  data?: any
  budget_id?: any
 }>({
  show: false,
  data: null,
  budget_id: null,
 })
 const [deleteBudget] = useDeleteBudgetMutation()

 const handleRemoveBudget = (id?: any) => {
  globalConfirm({
   content: 'Are you sure want remove Budget from this Lead?',
   onOk: async () => {
    await deleteBudget({ budget_id: id }).unwrap()
   },
  })
 }

 return (
  <div className="mb-3">
   <ProInnerCard
    title="Budget"
    onCLickAdd={isTransferred ? () => setShowModal({ show: true }) : undefined}
    isEmpty={!budget || budget?.length === 0}
    emptyText="No Budget Added"
   >
    {budget && budget?.length !== 0 && (
     <Row gutter={[15, 15]}>
      {budget?.map((item, key) => (
       <Col span={24} key={key}>
        <SimpleBlockItem
         text={item.budget}
         onEdit={
          isTransferred
           ? () =>
              setShowModal({
               show: true,
               data: item.budget,
               budget_id: item.id,
              })
           : undefined
         }
         onDelete={
          isTransferred ? () => handleRemoveBudget(item.id) : undefined
         }
        />
       </Col>
      ))}
     </Row>
    )}
   </ProInnerCard>
   {showModal.show && (
    <AddBudgetModal
     visible={showModal.show}
     onCancel={() => setShowModal({ show: false })}
     budget={showModal.data}
     id={showModal.budget_id}
    />
   )}
  </div>
 )
}

export default BudgetBlock
